import * as BABYLON from "babylonjs";

import { setState, setProgress } from "store/game";
import store from "store";

import gsap from "gsap/gsap-core";
import qs from "query-string";
import RootObjects from "./RootObjects";
import LevelManager from "./LevelManager";
import AudioManager from "scripts/util/AudioManager";
import Main from "scripts/3d/experience/Main";
import Snowmen from "scripts/3d/game/Snowmen";
import AssetLoader from "../loaders/AssetLoader";

const TRACK_SEGMENT_TOTAL = 360 / 15;
const TRACK_SEGMENT_SIZE = (Math.PI * 2) / TRACK_SEGMENT_TOTAL;

const BASE_SPEED = 0.00065;
const SPEED_DAMPENER = 0.1;
const BOOST = 0.00035;
const BOOST_TIME = 3;
const SLOWDOWN = -0.0002;
const SLOWDOWN_TIME = 1;
const STAR_TIME = 15;
const SNOWBALL_TIME = 9;

class Track {
  constructor(view, cave, caveEntrance, eventCallback, VFX, postProcess) {
    // , red, green) {
    // this.red = red;
    // this.green = green;
    this.postProcess = postProcess;
    this.eventCallback = eventCallback;
    this.sled = null;

    this.progress = 0;
    this.points = 0;
    this.time = 60;

    this.VFX = VFX;

    this.currentTrackIndex = 0;
    const parsedQuery = qs.parse(window.location.search);

    this.initialSpeed = parsedQuery.speed
      ? Number(parsedQuery.speed)
      : BASE_SPEED;
    this.boostOffset = 0;
    this.boostTime = 0;
    this.slowdownOffset = 0;
    this.slowdownTime = 0;
    this.slowdownInterval = null;
    this.starTime = 0;
    this.starInterval = null;
    this.snowballActive = false;

    const levels = [
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "start",
      "end",
      "shortcut",
    ];
    if (parsedQuery.level && levels.includes(parsedQuery.level)) {
      this.useLevel = parsedQuery.level;
      LevelManager.setLevel(this.useLevel);
    }

    this.speed = this.initialSpeed;

    this.view = view;
    this.trackGroup = new BABYLON.TransformNode("tracks");
    this.trackGroup.position.y = -500;

    //--------------PLACE CAVE
    cave.getChildren((mesh) => {
      if (mesh.name.includes("Tube")) {
        const lmap = AssetLoader.getTexture("LightingCave");
        mesh.material.lightmapTexture = lmap;
        mesh.material.lightmapTexture.uAng = Math.PI;
      }
      if (mesh.name.includes("Tube001")) {
        this.tube = mesh;
      }
      if (mesh.name.includes("Tube002")) {
        this.tube2 = mesh;
      }
      if (mesh.name.includes("Tube003")) {
        this.tube3 = mesh;
      }
      if (mesh.name.includes("Tube004")) {
        this.tube4 = mesh;
      }
      if (mesh.name.includes("hitbox_tunnel_in")) {
        this.caveEntranceMesh = mesh;
      }
      if (mesh.name.includes("hitbox_tunnel_out")) {
        this.caveExitMesh = mesh;
      }
    }, false);

    this.tube2.setParent(this.tube);
    this.tube3.setParent(this.tube);
    this.tube4.setParent(this.tube);

    const lmapEntrance = AssetLoader.getTexture("LightingCaveEntrance");
    caveEntrance.material.lightmapTexture = lmapEntrance;
    caveEntrance.material.lightmapTexture.uAng = Math.PI;
    // console.log(
    //   "CAVE ENTRANCE MATERIAL!!!!",
    //   caveEntrance.material,
    //   lmapEntrance
    // );

    caveEntrance.setParent(this.tube);

    this.caveEntranceMesh.setParent(this.tube);
    this.caveEntranceMesh.isPickable = false;
    this.caveEntranceMesh.checkCollisions = false;
    this.caveEntranceMesh.isVisible = false;

    this.caveExitMesh.setParent(this.tube);
    this.caveExitMesh.isPickable = false;
    this.caveExitMesh.checkCollisions = false;
    this.caveExitMesh.isVisible = false;

    this.tube.rotationQuaternion = null;
    this.tube.setParent(this.trackGroup);
    this.tube.name = "CAVETUBE";

    this.tube.rotation.x = (-Math.PI / 4) * 2;

    this.cave = this.tube;
    this.caveEntered = false;
    this.caveExited = false;

    this.createTracks();
    this.createLevels();

    this.interval = setInterval(() => {
      store.dispatch(setProgress(this.progress));
    }, 250);
  }

  stop() {
    clearInterval(this.interval);
  }

  createTracks() {
    let trackBase = null;
    this.view.getChildren((mesh) => {
      if (mesh.name.includes("Track")) trackBase = mesh;
      // if (mesh.name.includes("Tube")) caveTube = mesh;
      // if (mesh.name.includes("entrance")) caveEntrance = mesh;
    }, false);
    trackBase.isVisible = false;

    // RED+GREEN DEBUGGERS
    // let trackRed = null;
    // let trackGreen = null;
    // this.red.getChildren((mesh) => {
    //   if (mesh.name.includes("Track")) trackRed = mesh;
    // }, false);
    // this.green.getChildren((mesh) => {
    //   if (mesh.name.includes("Track")) trackGreen = mesh;
    // }, false);
    // trackRed.isVisible = false;
    // trackGreen.isVisible = false;

    const t1 = trackBase.createInstance("track1");
    t1.rotationQuaternion = null;
    t1.parent = this.trackGroup;
    t1.isVisible = true;
    t1.position.y = 0;

    const t2 = trackBase.createInstance("track2");
    // const t2 = trackRed.createInstance("track2");
    t2.rotationQuaternion = null;
    t2.parent = this.trackGroup;
    t2.position.y = 0;

    const t3 = trackBase.createInstance("track3");
    // const t3 = trackGreen.createInstance("track3");
    t3.rotationQuaternion = null;
    t3.parent = this.trackGroup;
    t3.position.y = 0;

    // caveTubes
    // const c1 = caveTube.createInstance("cave1");
    // const c2 = caveTube.createInstance("cave1");
    // const c3 = caveTube.createInstance("cave1");
    // c1.setParent(t1);
    // c2.setParent(t2);
    // c3.setParent(t3);

    this.tracks = [t1, t2, t3];
    this.placeNewTrack();
  }

  placeNewTrack() {
    const nextTrackIndex = (this.currentTrackIndex + 1) % TRACK_SEGMENT_TOTAL;
    const nextTrack = this.tracks[nextTrackIndex % 3];
    nextTrack.isVisible = true;
    nextTrack.rotation.x = -TRACK_SEGMENT_SIZE * nextTrackIndex;
  }

  createLevels() {
    LevelManager.init(this.trackGroup);
  }

  placeNewLevel() {
    LevelManager.placeNewLevel();
  }

  bounceBack() {
    if (window.location.search.includes("invincible")) return;
    this.speed = -(this.initialSpeed + this.boostOffset) * 2;
    RootObjects.getObject("sled").hit();
    this.killBoost();
    if (this.starTime <= 0) {
      this.updatePoints(-10);
    }
    AudioManager.playSound("hit");
  }

  spinOut() {
    if (this.starTime > 0 || window.location.search.includes("invincible")) return;
    RootObjects.getObject("sled").hitIcePatch();
    this.killBoost();
    this.updatePoints(-10);
    this.slowdownInterval = setInterval(() => {
      this.slowdownTick();
    }, 500)
    AudioManager.playSound("icePatch");
  }

  updatePoints(amount) {
    this.points += amount;
    store.dispatch(setState({ points: this.points }));
  }

  checkCollisions(target) {
    if (this.speed < 0) return;
    // this.checkObstacles(target)
    if (target.name === "SledCollider") {
      this.checkColliders(target);
      this.checkRocks(target);
      this.checkIcePatches(target);
    }
    this.checkPresents(target);
    this.checkTimebonus(target);
    this.checkBoosts(target);
    this.checkStars(target);
    this.checkSnowballs(target);
    this.checkSnowmen(target);
  }

  checkSnowmen(target) {
    // for (var i = 0; i < LevelManager.currentLevel.snowmen.length; i++) {
    //   const snowman = LevelManager.currentLevel.snowmen[i];
    //   snowman.update();
    // }
    Snowmen.update();
  }

  checkColliders(target) {
    for (var i = 0; i < LevelManager.currentLevel.colliders.length; i++) {
      const collider = LevelManager.currentLevel.colliders[i];
      if (target.intersectsMesh(collider, false)) {
        const noCollision = this.snowballActive && collider.name.includes('Tree');
        if (!noCollision) this.bounceBack();
      }
    }

    // CHECK CAVE COLLISIONS
    if (!this.caveEntered) {
      if (target.intersectsMesh(this.caveEntranceMesh, false)) {
        console.log("CAVE ENTERED!!!!");
        this.caveEntered = true;
        this.snow.stop();
        if (this.postProcess) this.postProcess.vignetteEnabled = true;
        // const scene = RootObjects.getObject("scene");
        // gsap.to(scene, {
        //   duration: 1,
        //   environmentIntensity: 1.0,
        // });
        gsap.to(this.postProcess, {
          duration: 1,
          vignetteWeight: 10,
        });
      }
    }
    if (!this.caveExited) {
      if (target.intersectsMesh(this.caveExitMesh, false)) {
        console.log("CAVE EXITED!!!!");
        this.snow.restart();
        this.caveExited = true;
        // const scene = RootObjects.getObject("scene");
        // gsap.to(scene, {
        //   duration: 1,
        //   environmentIntensity: 1.8,
        // });
        if (this.postProcess) this.postProcess.vignetteEnabled = true;
        gsap.to(this.postProcess, {
          duration: 1,
          vignetteWeight: 0,
        });
      }
    }
  }

  setPost(postProcess) {
    this.postProcess = postProcess;
  }

  setSnow(snow) {
    this.snow = snow;
  }

  checkPresents(target) {
    for (var i = 0; i < LevelManager.currentLevel.presents.length; i++) {
      const present = LevelManager.currentLevel.presents[i];
      present.update();
      if (
        present.isHit === false &&
        target.intersectsMesh(present.collider, false)
      ) {
        present.hit();
        this.starTime > 0 ? this.updatePoints(present.points * 2) : this.updatePoints(present.points);
      }
    }
  }

  checkRocks(target) {
    const sled = RootObjects.getObject("sled");
    for (var i = 0; i < LevelManager.currentLevel.rocks.length; i++) {
      const rock = LevelManager.currentLevel.rocks[i];
      if (rock.isHit === false && target.intersectsMesh(rock.view, false) && !this.snowballActive) {
        if (sled.velocity < 0) {
          sled.bounce();
          rock.hit();
        } else {
          this.bounceBack();
        }
      }
    }
  }

  checkIcePatches(target) {
    for (var i = 0; i < LevelManager.currentLevel.icePatches.length; i++) {
      const icePatch = LevelManager.currentLevel.icePatches[i];
      if (icePatch.isHit === false && target.intersectsMesh(icePatch.collider, false) && !this.snowballActive) {
        icePatch.hit();
        this.spinOut();
        if (this.starTime <= 0) {
          this.slowdownTime += SLOWDOWN_TIME;
          this.slowdownOffset = SLOWDOWN;
        }
      }
    }
  }

  slowdownTick() {
    if (this.slowdownTime > 0) {
      this.slowdownTime -= 0.5;
      this.slowdownOffset = this.slowdownOffset * 2;
      if (this.slowdownTime === 0) {
        this.killSlowdown();
      }
    }
  }

  killSlowdown(immediate) {
    this.slowdownOffset = 0;
    clearInterval(this.slowdownInterval);
    if (immediate) {
      this.speed = this.initialSpeed;
    }
  }

  checkTimebonus(target) {
    for (var i = 0; i < LevelManager.currentLevel.time.length; i++) {
      const time = LevelManager.currentLevel.time[i];
      time.update();
      if (time.isHit === false && target.intersectsMesh(time.collider, false)) {
        time.hit();
        this.updatePoints(25);
        this.eventCallback("Time");
      }
    }
  }

  checkBoosts(target) {
    for (var i = 0; i < LevelManager.currentLevel.boosts.length; i++) {
      const boost = LevelManager.currentLevel.boosts[i];
      if (
        boost.isHit === false &&
        target.intersectsMesh(boost.collider, false)
      ) {
        this.updatePoints(20);
        if (this.snowballActive) return
        boost.hit();
        this.boostTime = BOOST_TIME;
        this.boostOffset = BOOST;
        if (
          !window.location.search.includes("debug") &&
          !window.location.search.includes("dev")
        ) {
          gsap.to(RootObjects.getObject("camera"), {
            duration: 0.3,
            radius: 8,
          });
        }
      }
    }
  }

  boostTick() {
    if (this.boostTime > 0) {
      this.boostTime--;
      if (this.boostTime === 0) {
        this.killBoost();
      }
    }
  }

  killBoost(immediate) {
    this.boostOffset = 0;
    if (
      !window.location.search.includes("debug") &&
      !window.location.search.includes("dev") && 
      RootObjects.getObject('sled').isSnowball === false
    ) {
      gsap.to(RootObjects.getObject("camera"), { duration: 0.3, radius: 5 });
    }
    if (immediate) {
      this.speed = this.initialSpeed;
    }
    this.VFX.boostOff();
  }

  checkStars(target) {
    const sled = RootObjects.getObject("sled");
    for (var i = 0; i < LevelManager.currentLevel.stars.length; i++) {
      const star = LevelManager.currentLevel.stars[i];
      star.update();
      if (star.isHit === false && target.intersectsMesh(star.collider, false)) {
        sled.startStarPower();
        star.hit();
        this.VFX.addRainbow();
        this.updatePoints(25);
        this.starTime = STAR_TIME;
        clearInterval(this.starInterval);
        this.starInterval = setInterval(() => {
          this.starPowerTick();
        }, 1000)
      }
    }
  }

  starPowerTick() {
    if (this.starTime > 0) {
      this.starTime--;
      if (this.starTime === 0) {
        this.killStarPower();
      }
    }
  }

  killStarPower() {
    const sled = RootObjects.getObject("sled");
    sled.stopStarPower();
    AudioManager.playSound("starFadeOut");
    clearInterval(this.starInterval);
    this.VFX.removeRainbow();
  }

  checkSnowballs(target) {
    const sled = RootObjects.getObject("sled");
    for (var i = 0; i < LevelManager.currentLevel.snowballs.length; i++) {
      const snowball = LevelManager.currentLevel.snowballs[i];
      snowball.update();
      if (snowball.isHit === false && target.intersectsMesh(snowball.collider, false)) {
        sled.startSnowball();
        this.snowballActive = true;
        snowball.hit();
        setTimeout(() => {
          this.killSnowball();
        }, SNOWBALL_TIME * 1000)
      }
    }
  }

  killSnowball() {
    const sled = RootObjects.getObject("sled");
    sled.stopSnowball(this.trackGroup); 
    this.snowballActive = false;
    AudioManager.playSound("snowball");
  }

  update() {
    const ratio = RootObjects.getObject("scene").getAnimationRatio();

    const speed = this.speed;
    const target = this.initialSpeed + this.boostOffset + this.slowdownOffset;

    if (speed <= 0) Main.VFX.backingUp();
    else Main.VFX.notBackingUp();

    if (speed !== target) {
      const diff = target - speed;
      const multiplier = diff > 0 ? 1 : -1;
      const dampener = multiplier * target * SPEED_DAMPENER;
      this.speed = diff < speed * SPEED_DAMPENER ? target : speed + dampener;
    } else {
      this.speed = speed;
    }

    let nextRotation = (this.trackGroup.rotation.x += this.speed * ratio);
    if (nextRotation > Math.PI * 2) {
      nextRotation -= Math.PI * 2;
    }

    let trackIndex = Math.floor(nextRotation / TRACK_SEGMENT_SIZE);
    if (this.currentTrackIndex !== trackIndex) {
      // NEW TRACK!!!
      this.currentTrackIndex = trackIndex;
      this.placeNewTrack();
    }

    LevelManager.update(nextRotation);

    this.trackGroup.rotation.x = nextRotation;

    this.progress = nextRotation / (TRACK_SEGMENT_SIZE * 12);
  }
}

export default Track;
